import Vue from 'vue';
import VueRouter from 'vue-router';

import core from '@/modules/core/routes';
import user from '@/modules/user/routes';
import catalog from '@/modules/catalog/routes';
import home from '@/modules/home/routes';
import level4 from '@/modules/level4/routes';
import checkout from '@/modules/checkout/routes';
import page from '@/modules/page/routes';

Vue.use(VueRouter);

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
// component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),

const routes = [
  ...home,
  ...user,
  ...catalog,
  ...level4,
  ...core,
  ...checkout,
  ...page,
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
